import DownloadIcon from '@mui/icons-material/Download'
import { IconButton } from '@mui/material'
import html2canvas from 'html2canvas'
import { ReactNode, RefObject, useMemo, useRef } from 'react'
import { downloadFile } from '../../utils/downloadFile'

export type SnapshotDownloaderChild = {
  subjectRef: RefObject<HTMLDivElement>
}

type SnapshotDownloaderProps = {
  children(props: SnapshotDownloaderChild): ReactNode
  filename: string
  buttonPosition?: { top: number; right: number }
}

export const SnapshotDownloader = ({
  children,
  filename,
  buttonPosition = { top: 18, right: 18 },
}: SnapshotDownloaderProps) => {
  const subjectRef = useRef<HTMLDivElement>(null)

  const downloadName = useMemo(() => {
    if (filename.match(/\.png$/)) {
      return filename
    }

    return `${filename.replaceAll(' ', '_')}.png`
  }, [filename])

  return (
    <div style={{ position: 'relative' }}>
      <IconButton
        color="secondary"
        aria-label={`download ${downloadName}`}
        onClick={() => {
          if (!subjectRef.current) {
            return console.warn('SnapshotDownloader: subjectRef not set')
          }

          html2canvas(subjectRef.current).then(canvas => {
            const pngData = canvas.toDataURL('image/png').split(',')[1]

            const base64String = atob(pngData)
            const arrayBuffer = new ArrayBuffer(base64String.length)
            const uint8Array = new Uint8Array(arrayBuffer)

            for (let i = 0; i < base64String.length; i++) {
              uint8Array[i] = base64String.charCodeAt(i)
            }

            const blob = new Blob([arrayBuffer], { type: 'image/png' })

            downloadFile({
              blob,
              filename: downloadName,
            })
          })
        }}
        style={{ position: 'absolute', ...buttonPosition }}
      >
        <DownloadIcon />
      </IconButton>

      {children({ subjectRef })}
    </div>
  )
}
